import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

// Canonical display timezone. Rendering every calendar date in a single fixed
// timezone keeps the SSR output and the client's first render byte-identical,
// which is required to avoid React hydration mismatches (error #425).
export const DISPLAY_TIMEZONE = 'Asia/Tokyo'

/**
 * Format a date deterministically in the canonical display timezone.
 * Use this for calendar dates (e.g. release dates) that mean "this day in
 * Japan" rather than a per-viewer local time.
 */
export const formatDate = (
  date: dayjs.ConfigType,
  template = 'YYYY/MM/DD',
): string => dayjs(date).tz(DISPLAY_TIMEZONE).format(template)

/**
 * Full ISO-8601 (UTC) string for a `<time dateTime>` attribute. Always
 * unambiguous regardless of the timezone used for the human-readable text.
 */
export const toISO = (date: dayjs.ConfigType): string =>
  dayjs(date).utc().toISOString()

export default dayjs
